// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: this rule targets .oracle-access-report (a copy-paste leftover from
   when this file was cloned). Because CSS is global, it co-exists with the
   same selector in OracleUserAccessReport.css and — loading later — wins. Kept
   full-width here so it does NOT re-cap the Oracle/Postgres reports at 1600px.
   The MySQL/MSSQL reports use the .mysql-access-report wrapper (below). */
.oracle-access-report {
  padding: 20px;
  max-width: 100%;
  margin: 0;
}

/* The actual wrapper class for the MySQL and MSSQL reports. Full-width with
   the same 20px gutter as the other report pages. */
.mysql-access-report {
  padding: 20px;
  max-width: 100%;
  margin: 0;
}

/* Header */
.report-header {
  margin-bottom: 30px;
  border-bottom: 3px solid #1f2937;
  padding-bottom: 15px;
}

.report-header h2 {
  color: #1f2937;
  margin: 0 0 5px 0;
  font-size: 28px;
}

.report-subtitle {
  color: #6b7280;
  margin: 0;
  font-size: 14px;
}

/* Summary Cards */
.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
  margin-bottom: 30px;
}

.summary-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

.summary-card.warning {
  border-left: 4px solid #f59e0b;
}

.summary-card.danger {
  border-left: 4px solid #ef4444;
}

.summary-label {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.summary-value {
  font-size: 32px;
  font-weight: bold;
  color: #1f2937;
}

/* Filters */
.filters-section {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.filters-section h3 {
  margin: 0 0 15px 0;
  color: #1f2937;
  font-size: 18px;
}

.filters-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: flex-end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  min-width: 180px;
  flex: 0 1 auto;
}

.filter-group label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-group select,
.filter-group input {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.filter-group select:focus,
.filter-group input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.filter-actions {
  display: flex;
  gap: 10px;
  align-items: flex-end;
}

/* Export Section */
.export-section {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: flex-end;
}

/* Buttons */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.btn:hover {
  transform: translateY(-1px);
}

.btn:active {
  transform: translateY(0);
}

.btn-primary {
  background-color: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background-color: #2563eb;
}

.btn-secondary {
  background-color: #6b7280;
  color: white;
}

.btn-secondary:hover {
  background-color: #4b5563;
}

.btn-export {
  background-color: #10b981;
  color: white;
}

.btn-export:hover {
  background-color: #059669;
}

.btn-small {
  padding: 6px 12px;
  font-size: 12px;
}

/* Error Message */
.error-message {
  background-color: #fee2e2;
  border: 1px solid #ef4444;
  color: #991b1b;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.error-message button {
  background: none;
  border: none;
  color: #991b1b;
  font-size: 18px;
  cursor: pointer;
  padding: 0 5px;
}

/* Loading */
.loading {
  text-align: center;
  padding: 40px;
  color: #6b7280;
  font-size: 16px;
}

/* Users Table */
.users-table-container {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
}

.users-table-container h3 {
  margin: 0 0 15px 0;
  color: #1f2937;
  font-size: 18px;
}

.table-wrapper {
  overflow-x: auto;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.users-table thead {
  background-color: #1f2937;
  color: white;
}

.users-table th {
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.5px;
}

.users-table tbody tr {
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.2s;
}

.users-table tbody tr:hover {
  background-color: #f9fafb;
}

.users-table tbody tr.critical-row {
  background-color: #fef2f2;
}

.users-table td {
  padding: 12px 8px;
}

.username-cell {
  font-weight: 600;
  color: #1f2937;
}

.critical-cell {
  color: #dc2626;
  font-weight: 700;
}

.high-risk-cell {
  color: #f59e0b;
  font-weight: 600;
}

/* Badges */
.risk-badge,
.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.risk-badge.critical {
  background-color: #fee2e2;
  color: #991b1b;
}

.risk-badge.high {
  background-color: #fef3c7;
  color: #92400e;
}

.risk-badge.medium {
  background-color: #dbeafe;
  color: #1e40af;
}

.risk-badge.low {
  background-color: #d1fae5;
  color: #065f46;
}

.status-badge.open {
  background-color: #d1fae5;
  color: #065f46;
}

.status-badge.locked {
  background-color: #fee2e2;
  color: #991b1b;
}

.status-badge.expired {
  background-color: #fef3c7;
  color: #92400e;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 8px;
  max-width: min(95vw, 900px);
  width: 900px;
  min-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 2px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
}

.modal-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #ffffff;
  cursor: pointer;
  padding: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s, transform 0.1s;
  opacity: 0.9;
}

.modal-close:hover {
  background-color: rgba(255, 255, 255, 0.1);
  opacity: 1;
  transform: scale(1.1);
}

.modal-body {
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1 1;
}

.modal-footer {
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  background-color: #f9fafb;
}

/* Detail Sections */
.detail-section {
  margin-bottom: 20px;
}

.detail-section h4 {
  color: #374151;
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
}

.detail-label {
  font-weight: 500;
  color: #6b7280;
  font-size: 12px;
}

.detail-value {
  color: #1f2937;
  font-size: 12px;
  font-weight: 400;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  padding: 5px 8px;
  background-color: #f9fafb;
  border-radius: 4px;
  font-size: 10px;
}

.stat-label {
  color: #6b7280;
  text-transform: capitalize;
  font-weight: 400;
  font-size: 10px;
}

.stat-value {
  font-weight: 400;
  color: #1f2937;
  font-size: 10px;
}

/* Privilege List */
.privilege-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
}

.privilege-item {
  display: flex;
  gap: 10px;
  padding: 10px;
  border-bottom: 1px solid #f3f4f6;
  align-items: center;
}

.privilege-item:last-child {
  border-bottom: none;
}

.priv-name {
  flex: 1 1;
  font-weight: 400;
  color: #1f2937;
  font-size: 12px;
}

.priv-source,
.priv-type,
.priv-capability {
  font-size: 11px;
  color: #6b7280;
  background-color: #f3f4f6;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 400;
}

.more-items {
  padding: 10px;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 12px;
}

/* Privilege Level Badges */
.privilege-level-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.privilege-level-none,
.privilege-level-n-a {
  background-color: #f3f4f6;
  color: #6b7280;
}

.privilege-level-read {
  background-color: #dbeafe;
  color: #1e40af;
}

.privilege-level-read-elevated {
  background-color: #bfdbfe;
  color: #1e3a8a;
}

.privilege-level-write {
  background-color: #fef3c7;
  color: #92400e;
}

.privilege-level-write-elevated {
  background-color: #fde68a;
  color: #78350f;
}

.privilege-level-admin {
  background-color: #fed7aa;
  color: #9a3412;
}

.privilege-level-super-admin {
  background-color: #fee2e2;
  color: #991b1b;
}

/* Responsive Design */
@media (max-width: 768px) {
  .oracle-access-report {
    padding: 10px;
  }

  .summary-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .filters-grid {
    grid-template-columns: 1fr;
  }

  .users-table {
    font-size: 11px;
  }

  .users-table th,
  .users-table td {
    padding: 8px 4px;
  }

  .modal-content {
    max-width: 100%;
    min-width: 300px;
    margin: 10px;
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }
}

/* Print Styles */
@media print {
  .filters-section,
  .export-section,
  .btn {
    display: none;
  }

  .modal-overlay {
    position: static;
    background: white;
  }

  .modal-content {
    max-height: none;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MySQLUserAccessReport.css"],"names":[],"mappings":"AAAA;;;;0EAI0E;AAC1E;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;oDACoD;AACpD;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,iBAAiB;AACjB;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["/* NOTE: this rule targets .oracle-access-report (a copy-paste leftover from\n   when this file was cloned). Because CSS is global, it co-exists with the\n   same selector in OracleUserAccessReport.css and — loading later — wins. Kept\n   full-width here so it does NOT re-cap the Oracle/Postgres reports at 1600px.\n   The MySQL/MSSQL reports use the .mysql-access-report wrapper (below). */\n.oracle-access-report {\n  padding: 20px;\n  max-width: 100%;\n  margin: 0;\n}\n\n/* The actual wrapper class for the MySQL and MSSQL reports. Full-width with\n   the same 20px gutter as the other report pages. */\n.mysql-access-report {\n  padding: 20px;\n  max-width: 100%;\n  margin: 0;\n}\n\n/* Header */\n.report-header {\n  margin-bottom: 30px;\n  border-bottom: 3px solid #1f2937;\n  padding-bottom: 15px;\n}\n\n.report-header h2 {\n  color: #1f2937;\n  margin: 0 0 5px 0;\n  font-size: 28px;\n}\n\n.report-subtitle {\n  color: #6b7280;\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Summary Cards */\n.summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 15px;\n  margin-bottom: 30px;\n}\n\n.summary-card {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.summary-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);\n}\n\n.summary-card.warning {\n  border-left: 4px solid #f59e0b;\n}\n\n.summary-card.danger {\n  border-left: 4px solid #ef4444;\n}\n\n.summary-label {\n  font-size: 12px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n.summary-value {\n  font-size: 32px;\n  font-weight: bold;\n  color: #1f2937;\n}\n\n/* Filters */\n.filters-section {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.filters-section h3 {\n  margin: 0 0 15px 0;\n  color: #1f2937;\n  font-size: 18px;\n}\n\n.filters-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  align-items: flex-end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  min-width: 180px;\n  flex: 0 1 auto;\n}\n\n.filter-group label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filter-group select,\n.filter-group input {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.filter-group select:focus,\n.filter-group input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.filter-actions {\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n}\n\n/* Export Section */\n.export-section {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  justify-content: flex-end;\n}\n\n/* Buttons */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.1s;\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n}\n\n.btn:active {\n  transform: translateY(0);\n}\n\n.btn-primary {\n  background-color: #3b82f6;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #2563eb;\n}\n\n.btn-secondary {\n  background-color: #6b7280;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background-color: #4b5563;\n}\n\n.btn-export {\n  background-color: #10b981;\n  color: white;\n}\n\n.btn-export:hover {\n  background-color: #059669;\n}\n\n.btn-small {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n/* Error Message */\n.error-message {\n  background-color: #fee2e2;\n  border: 1px solid #ef4444;\n  color: #991b1b;\n  padding: 12px 16px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.error-message button {\n  background: none;\n  border: none;\n  color: #991b1b;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0 5px;\n}\n\n/* Loading */\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #6b7280;\n  font-size: 16px;\n}\n\n/* Users Table */\n.users-table-container {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.users-table-container h3 {\n  margin: 0 0 15px 0;\n  color: #1f2937;\n  font-size: 18px;\n}\n\n.table-wrapper {\n  overflow-x: auto;\n}\n\n.users-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.users-table thead {\n  background-color: #1f2937;\n  color: white;\n}\n\n.users-table th {\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 0.5px;\n}\n\n.users-table tbody tr {\n  border-bottom: 1px solid #e5e7eb;\n  transition: background-color 0.2s;\n}\n\n.users-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n\n.users-table tbody tr.critical-row {\n  background-color: #fef2f2;\n}\n\n.users-table td {\n  padding: 12px 8px;\n}\n\n.username-cell {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.critical-cell {\n  color: #dc2626;\n  font-weight: 700;\n}\n\n.high-risk-cell {\n  color: #f59e0b;\n  font-weight: 600;\n}\n\n/* Badges */\n.risk-badge,\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.risk-badge.critical {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.risk-badge.high {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.risk-badge.medium {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.risk-badge.low {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.open {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.locked {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.status-badge.expired {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  max-width: min(95vw, 900px);\n  width: 900px;\n  min-width: 700px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  padding: 20px 24px;\n  border-bottom: 2px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #ffffff;\n  cursor: pointer;\n  padding: 0;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s, transform 0.1s;\n  opacity: 0.9;\n}\n\n.modal-close:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.modal-body {\n  padding: 16px 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-footer {\n  padding: 12px 20px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  background-color: #f9fafb;\n}\n\n/* Detail Sections */\n.detail-section {\n  margin-bottom: 20px;\n}\n\n.detail-section h4 {\n  color: #374151;\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  font-weight: 600;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 0;\n}\n\n.detail-label {\n  font-weight: 500;\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.detail-value {\n  color: #1f2937;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 8px;\n}\n\n.stat-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 8px;\n  background-color: #f9fafb;\n  border-radius: 4px;\n  font-size: 10px;\n}\n\n.stat-label {\n  color: #6b7280;\n  text-transform: capitalize;\n  font-weight: 400;\n  font-size: 10px;\n}\n\n.stat-value {\n  font-weight: 400;\n  color: #1f2937;\n  font-size: 10px;\n}\n\n/* Privilege List */\n.privilege-list {\n  max-height: 300px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n}\n\n.privilege-item {\n  display: flex;\n  gap: 10px;\n  padding: 10px;\n  border-bottom: 1px solid #f3f4f6;\n  align-items: center;\n}\n\n.privilege-item:last-child {\n  border-bottom: none;\n}\n\n.priv-name {\n  flex: 1;\n  font-weight: 400;\n  color: #1f2937;\n  font-size: 12px;\n}\n\n.priv-source,\n.priv-type,\n.priv-capability {\n  font-size: 11px;\n  color: #6b7280;\n  background-color: #f3f4f6;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-weight: 400;\n}\n\n.more-items {\n  padding: 10px;\n  text-align: center;\n  color: #6b7280;\n  font-style: italic;\n  font-size: 12px;\n}\n\n/* Privilege Level Badges */\n.privilege-level-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.privilege-level-none,\n.privilege-level-n-a {\n  background-color: #f3f4f6;\n  color: #6b7280;\n}\n\n.privilege-level-read {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.privilege-level-read-elevated {\n  background-color: #bfdbfe;\n  color: #1e3a8a;\n}\n\n.privilege-level-write {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.privilege-level-write-elevated {\n  background-color: #fde68a;\n  color: #78350f;\n}\n\n.privilege-level-admin {\n  background-color: #fed7aa;\n  color: #9a3412;\n}\n\n.privilege-level-super-admin {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .oracle-access-report {\n    padding: 10px;\n  }\n\n  .summary-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .filters-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .users-table {\n    font-size: 11px;\n  }\n\n  .users-table th,\n  .users-table td {\n    padding: 8px 4px;\n  }\n\n  .modal-content {\n    max-width: 100%;\n    min-width: 300px;\n    margin: 10px;\n  }\n\n  .detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .filters-section,\n  .export-section,\n  .btn {\n    display: none;\n  }\n\n  .modal-overlay {\n    position: static;\n    background: white;\n  }\n\n  .modal-content {\n    max-height: none;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
